import {useAppState} from "@/store";
import Input from "@/components/fields/Input";

export default function PropertyStories({stateKey}) {

    const {state, setState} = useAppState()

    const handleChange = (v) => {
        setState((s) => {
            s[stateKey].stories = v.replace(/^0+/, '')
        })
    }

    return (
        <Input
            label={"Stories"}
            type={"text"}
            inputMode={"numeric"}
            maxLength={1}
            name={`${stateKey}.stories`}
            value={state[stateKey]?.stories || ''}
            placeholder={"Enter number of stories"}
            onChange={handleChange}
            required
        />
    )

}
